import { TreeTest } from '../../../shared/models/order-entry/test';

export class RequisitionTest {
    public testId?: number;
    public parentTestId?: number;
    public requisitionId?: number;
    public level?: number;
    public test?: TreeTest;
    public isConfidential?: boolean;
}
